import React, { useContext, useState, useEffect, useRef } from "react";
import "./Markers.scss";
import MarkerText from "./MarkerText";
import { PIN_OFFSETS } from "./markerUtils";
import { MapContext } from "../../../contexts/MapContext";

const PIN_SIZE = {width: 70, height: 70};

export default function Facility({ name, coords, align = "right" }) {
    const { zoom, isDragging } = useContext(MapContext);
    const inverseZoom = 1 / zoom;
    const groupRef = useRef(null);

    const bottomCenterCoords = [coords[0], coords[1] + PIN_SIZE.height / 2];

    const [onMouseOver, setOnMouseOver] = useState(false);
    const [isSelected, setIsSelected] = useState(false);

    const onMouseEnter = () => {
        setOnMouseOver(true);
    }

    const onMouseLeave = () => {
        setOnMouseOver(false);
    }

    // Check if the marker is selected by monitoring the selected-marker class
    useEffect(() => {
        if (!groupRef.current) return;
        
        const checkSelected = () => {
            setIsSelected(groupRef.current.classList.contains('selected-marker'));
        };

        // Initial check
        checkSelected();
        
        // Create a MutationObserver to monitor class changes
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class') {
                    checkSelected();
                }
            });
        });

        observer.observe(groupRef.current, { attributes: true });
        
        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <g
            ref={groupRef}
            className="marker-group-fac"
            data-coords={coords.join(",")}
            data-name={name}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <g
                className="marker-icon-group"
                style={{
                    transform: `scale(${inverseZoom})`,
                    transformOrigin: `${coords[0]}px ${coords[1]}px`,
                    transition: isDragging ? 'none' : 'transform 0.3s ease-out'
                }}
            >
                <svg
                    x={coords[0] - PIN_SIZE.width / 2}
                    y={coords[1] - PIN_SIZE.height / 2 + 15}
                    className="image-pins"
                    width={PIN_SIZE.width}
                    height={PIN_SIZE.height}
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >

                    <rect
                        x="-15"
                        y="-15"
                        width="50"
                        height="50"
                        fill="transparent"
                    />

                    <g filter="url(#filter0_d)">
                        <rect
                            x="4.84326"
                            y="5.65723"
                            width="8"
                            height="8"
                            transform="rotate(-45 4.84326 5.65723)"
                            fill="white"
                        />
                    </g>
                    <defs>
                        <filter
                            id="filter0_d"
                            x="0.843262"
                            y="0"
                            width="19.3137"
                            height="19.3145"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                            />
                            <feOffset dy="4"/>
                            <feGaussianBlur stdDeviation="2"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
                            />
                            <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow"
                                result="shape"
                            />
                        </filter>
                    </defs>
                </svg>

                {(onMouseOver || isSelected) &&
                    <MarkerText
                        name={name}
                        coords={bottomCenterCoords}
                        align={align}
                        pinSize={PIN_SIZE}
                        marginToNextLine={PIN_OFFSETS.default.marginToNextLine}
                        offsets={PIN_OFFSETS.default}
                    />
                }
            </g>
        </g>
    );
}
